import { defineStore } from "pinia";

export const useShowCaseStore = defineStore("showcase", {
  state: () => ({
    leftSideBar: false,
    rightSideBar: false,
    leftSideBarSettings: false,
  }),
  getters: {},
  actions: {
    setLeftSideBar(sideBar) {
      this.leftSideBar = sideBar;
    },
    toggleLeftSideBar() {
      this.leftSideBar = !this.leftSideBar;
    },
    setRightSideBar(sideBar) {
      this.rightSideBar = sideBar;
    },
    toggleRightSideBar() {
      this.rightSideBar = !this.rightSideBar;
    },
    setLeftSideBarSettings(sideBar) {
      this.leftSideBarSettings = sideBar;
    },
    toggleLeftSideBarSettings() {
      this.leftSideBarSettings = !this.leftSideBarSettings;
    },
  },
});
